<div class="card">
    <div class="card-body">
        <div mat-dialog-title class="heading">Redact Words From Document</div>
        <div *ngIf="!successMessage">
            <form [formGroup]="keywordsForm">

                <div formArrayName="keywords">
                    <div class="form-group row">
                        <div class="col mt-1 mb-2">
                            <button mat-stroked-button class="float-right" title="Add Form" (click)="addNewKeyword()">
                                <mat-icon>add</mat-icon>word
                            </button>
                        </div>
                    </div>
                    <div *ngFor="let item of getKeyword(keywordsForm); let i=index" [formGroupName]="i">
                        <div class="row">
                            <div class="input-group-sm mb-3 input-group col-11">
                                <input class="form-control" type="text" formControlName="keyword">
                            </div>
                            <div class="col-1 p-0" *ngIf="keywordsArray.controls.length > 1">
                                <mat-icon title="Remove" (click)="deleteKeyword(i)">delete</mat-icon>
                            </div>
                        </div>
                    </div>
                    <div class="float-right">
                        <button mat-raised-button class="actionButton mr-1" [disabled]="!keywordsForm.valid" (click)="redactDocumentHandler()">
                            Redact
                        </button>
                        <button mat-raised-button class="closeButton" (click)="onCancel()">
                            Back
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div class="mt-1" *ngIf="successMessage">
            <div>
                Document redaction complete.
            </div>
            <div class="float-right">
                <button mat-raised-button class="closeButton" (click)="onClose()">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>